<h2 mat-dialog-title class="dialog-header">
    <span class="title-large">{{ 'products.ui.rimuovereDalCarrello' | transloco }}</span>

    <button
        mat-icon-button
        type="button"
        [attr.aria-label]="'products.ui.chiudi' | transloco"
        (click)="onCancel()"
    >
        <i class="fa-regular fa-xmark"></i>
    </button>
</h2>

<mat-dialog-content class="content">
    <span class="body-medium">{{ 'products.ui.staiPerRimuovereDalCarrello' | transloco }}</span>

    <div class="product-card">
        <span class="body-medium emphasized">{{ data.nomeProdotto }}</span>
        <span class="body-small">{{ data.nomeImballo ?? '-' }} - {{ data.unitaFatturabile }} {{ data.unitaMisura }}</span>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
    <button matButton="filled" type="button" class="destructive" (click)="onConfirm()">{{ 'products.ui.rimuoviDalCarrello' | transloco }}</button>
    <button matButton type="button" (click)="onCancel()">{{ 'products.ui.annulla' | transloco }}</button>
</mat-dialog-actions>
